export default "__VITE_ASSET__CR1Zjkym__"